import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core'
import { AuthService, MatrixServices, SharedServices } from '@app/services'
import { imageUrl } from '@helpers/common'
import { AuthImagePipe } from '@app/pipes/auth-image.pipe'
import { HttpClient } from '@angular/common/http'

@Component({
    selector: 'app-simple-image',
    templateUrl: './simple-image.component.html',
    styleUrls: ['./simple-image.component.css'],
})
export class SimpleImageComponent {
    @Input() className = ''
    @Input() type = ''
    @Input() imageId: string
    @Input() imageMatrix = [1, 0, 0, 1]
    @Input() maxWidth = 250
    @Input() maxHeight = 250
    @Input() loadStyle: any = {
        transform: 'matrix(1, 0, 0, 1, 0, 0)',
    }
    @Output() _onShowed: EventEmitter<any> = new EventEmitter()
    @ViewChild('image') image: ElementRef

    loaded = false
    finalSrc = ''
    private statusType = false

    constructor(
        private _sharedService: SharedServices,
        public matrixServices: MatrixServices,
        public el: ElementRef,
        private http: HttpClient,
        private auth: AuthService,
    ) {
    }

    showBigImage(event, id, matrix) {
        event.stopPropagation()
        const changeImage = { id, imageSrc: this.image.nativeElement.src, matrix }
        this._onShowed.emit(true)
        this._sharedService.emitShowBigImage(changeImage)
    }

    onError = () => {
        if (this.type === 'medium') {
            this.type = 'other'
        } else if (this.type === 'other') {
            this.type = 'small'
        } else if (this.type === 'small') {
            this.type = ''
        }
        if (this.type === '' && !this.finalSrc) {
            this.finalSrc = 'loading'
            const authImage = new AuthImagePipe(this.http, this.auth)
            authImage.transform(imageUrl + this.imageId).then(url => {
                this.finalSrc = url
                this.image.nativeElement.src = url
            })
        }
    }

    onLoaded(container, image) {
        this.statusType = false
        this.loadStyle = this.matrixServices.loadMatrixImageHorizontalList(
            container,
            image,
            this.imageMatrix,
        )
    }
}



// WEBPACK FOOTER //
// ./src/app/commons/simple-image/simple-image.component.ts